<script setup>
import { computed } from 'vue'
import ActionMenuButton from '../src/ActionMenuButtonMenu.vue'
import { extActionButtonMenuProps } from '../src/props'
import { DEFAULT_FONT_WEIGHT_LIST, DEFAULT_FONT_WEIGHT_VALUE } from '@/tiptap/constants/define'

const props = defineProps(extActionButtonMenuProps())

const items = computed(() => {
  const fontWeights = props.extension?.options?.fontWeights || DEFAULT_FONT_WEIGHT_LIST
  const all = [DEFAULT_FONT_WEIGHT_VALUE, ...fontWeights]

  return all.map(weight => ({
    title: weight === DEFAULT_FONT_WEIGHT_VALUE ? props.t('editor.default') : String(weight),
    isActive: () => {
      const hasTextStyle = !!props.editor?.schema?.marks?.textStyle
      if (!hasTextStyle) return false
      const { fontWeight } = props.editor.getAttributes('textStyle')
      const isDefault = weight === DEFAULT_FONT_WEIGHT_VALUE
      const notFontWeight = fontWeight === undefined || fontWeight === null
      if (isDefault && notFontWeight) return true
      return props.editor.isActive?.('textStyle', { fontWeight: String(weight) }) || false
    },
    action: () => {
      const chain = props.editor.chain().focus()
      if (weight === DEFAULT_FONT_WEIGHT_VALUE) {
        if (chain.unsetFontWeight) chain.unsetFontWeight().run()
        return
      }
      if (chain.setFontWeight) chain.setFontWeight(String(weight)).run()
    },
    divider: weight === DEFAULT_FONT_WEIGHT_VALUE,
    default: weight === DEFAULT_FONT_WEIGHT_VALUE,
    style: weight === DEFAULT_FONT_WEIGHT_VALUE ? undefined : { fontWeight: String(weight) },
  }))
})
</script>

<template>
  <ActionMenuButton
    :editor="editor"
    :items="items"
    :max-height="320"
    :disabled="!(
      editor?.schema?.marks?.textStyle &&
      editor?.can?.().setFontWeight ? editor.can().setFontWeight('400') : false
    )"
    :tooltip="t('editor.fontWeight.tooltip')"
    icon="fontWeight"
  />
</template>
